// "64,3% · 1.834/2.850" — percentual junto do número puro. Um percentual
// sozinho esconde a base (64% de 7 respostas != 64% de 7.000); usado nos
// relatórios de CSAT e SLA. Separador de milhar explícito em pt-BR pra não
// confundir com a vírgula decimal do percentual.
export const formatMetricWithCount = (count, total) => {
  if (!total) return '--';
  const percent = ((count * 100) / total).toFixed(1).replace('.', ',');
  const formattedCount = count.toLocaleString('pt-BR');
  const formattedTotal = total.toLocaleString('pt-BR');
  return `${percent}% · ${formattedCount}/${formattedTotal}`;
};
